<template>
  <div class="createdOrder">
    <div class="clear">
      <h2 class="paging-title">子公司已发工单</h2>
      <button class="btn-default" @click="tapFast">快速发单</button>
    </div>
    <div class="filter-form">
      <div class="form-item">
        <span class="label">工单名称：</span>
        <div class="input-item">
          <input class="input" type="text" v-model.trim="form.JobTitle" placeholder="输入工单名称"  @keydown.enter="search" />
        </div>
      </div>
      <div class="form-item">
        <span class="label">工单号：</span>
        <div class="input-item">
          <input class="input" type="text" v-model.trim="form.JobNo" placeholder="输入工单号"  @keydown.enter="search" />
        </div>
      </div>
      <div class="form-item" style="margin-bottom: 10px;">
        <span class="label">平台：</span>
        <div class="input-item">
          <label
            class="radiobox"
            v-for="(item, index) in radios"
            :key="index"
          >
            <input name="source" type="radio" :value="item.value" v-model="form.JobType" @change="search" />
            <span class="radio-text">{{ item.label }}</span>
          </label>
        </div>
      </div>
      <div class="form-item" style="margin-bottom: 10px;">
        <span class="label">状态：</span>
        <div class="input-item">
          <label
            class="radiobox"
            v-for="(item, index) in stepType"
            :key="index"
          >
            <input name="status" type="radio" :value="item.value" v-model="form.JobSearchStep" @change="search" />
            <span class="radio-text">{{ item.label }}</span>
          </label>
        </div>
      </div>
      <div class="btn-all">
        <button class="btn-filter-bg" @click="search">查询</button>
        <button class="btn-filter-no-bg" @click="download">导出数据</button>
      </div>
    </div>
    <!-- 外部工单 -->
    <table class="table">
      <tr>
        <th>子公司名称</th>
        <th>工单名称</th>
        <th>来源</th>
        <th>城市</th>
        <th>发单时间</th>
        <th>上门时间</th>
        <th>金额/元</th>
        <th>状态</th>
      </tr>
      <tr v-for="(item,index) in tableData" :key="index" @click="toDetail(item.JobNo)">
        <td>{{item.ChildCompanyName}}</td>
        <td>
            <h3 class="item-title">
              <i class="icon-urgent" v-if="item.IsUrgent"></i>
              <i class="icon-hot" v-if="item.IsHotJob"></i>
              {{item.Title}}</h3>
            <p class="number-job">工单号：{{item.JobNo}}</p>
        </td>
        <td>{{item.JobTypeName}}</td>
        <td>{{item.ProvinceName}}·{{item.CityName}}</td>
        <td>{{item.CreateTime}}</td>
        <td>{{item.ExecStartDate}}至<br />{{item.ExecEndDate}}</td>
        <td>{{item.JobStepAmount}}</td>
        <td>
            {{item.JobStatus}}
            <div class="remark">
              {{item.JobStepName}}
            </div>
        </td>
      </tr>
      <tr v-if="tableData.length==0">
        <td class="no-data" colspan="8">暂无数据</td>
      </tr>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="pageIndex"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange">
    </el-pagination>
    <order-type :show="isShowCreateDialog" @choose="toCreateOrder" @close="isShowCreateDialog=false"></order-type>
  </div>
</template>
<script>
import {
  GetChildCompanySendJobList,
  DownChildCompanySendJobList
} from '@/scripts/api.js'
import { mapState, mapActions,mapGetters } from "vuex";
import OrderType from '@/components/orderType.vue'
export default {
  components:{
    OrderType
  },
  data(){
    return{
      tabs:[{
        text:'外部工单',
        id:1
      },{
        text:'内部工单',
        id:2
      }],
      radios:[
        {
          label:'全部',
          value:0
        },
        {
          label:'自由专区',
          value:1
        },
        {
          label:'B2B专区',
          value:6
        },
      ],
      stepType:[{
        label:'全部',
        value:0
      },{
        label:'匹配中',
        value:1
      },{
        label:'服务中',
        value:2
      },{
        label:'已完成',
        value:3
      },],
      listType:1,
      pageSize:10,
      pageIndex:1,
      total:0,
      form:{
        JobSearchStep: 0,
        JobType:0,
        JobTitle:'',
        JobNo:'',
      },
      tableData:[],
      loading:false,
      isShowCreateDialog:false,
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
    }),
    ...mapGetters({
      createTypes: "createTypes",
    }),
  },
  created() {
    this.loadData();
  },
  methods:{
    search(){
      this.pageIndex=1;
      this.loadData();
    },
    //获取列表
    loadData() {
      if (this.loading) return;
      this.loading = true;
      let params = {
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        CompanyId:this.userInfo.LoginAccountId,
        ...this.form,
      };
      GetChildCompanySendJobList(params).then((r) => {
        this.loading = false;
        if (r.Result == 1) {
          this.tableData = r.Data.List || [];
          this.total = r.Data.TotalRows;
        }else{
          this.$toast(r.Message);
        }
      });
    },
    pageChange(data){
      this.pageIndex=data;
      this.loadData();
    },
    //下载工单列表
    download() {
      let params = {
        CompanyId:this.userInfo.LoginAccountId,
        ...this.form,
        platform:'pcweb'
      };
      let str='';
      //拼接参数字符串
      for (const k in params) {
        if (Object.hasOwnProperty.call(params, k)) {
          str+=`${k}=${params[k]}&`
        }
      }
      DownChildCompanySendJobList(str)
    },
    //查看详情
    toDetail(data){
      // this.$router.push({path:'/createOrderProcess',query:{jobNo:data}});
    },
    //快速发单
    tapFast(){
      if(this.createTypes.length==0){
        this.$toast('您没有发单权限，请联系速派客服');
        return;
      }else if(this.createTypes.length==1){
        this.$router.push({
          path:'/createStep1',
          query:{
            jobType:this.createTypes[0].jobType
          }
        })
      }else{
        this.isShowCreateDialog=true;
      }
    },
    //选择发单类型
    toCreateOrder(item){
      this.$router.push({
        path:'/createStep1',
        query:{
          jobType:item.jobType
        }
      })
      this.isShowCreateDialog=false;
    },
  }
}
</script>
<style lang="scss">
.createdOrder{
  .tab-hd{
    margin-top: 30px;
    background-color: #fff;
    overflow:hidden;
    li{
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #333;
      cursor: pointer;
      float: left;
      &:before{
        content: "";
        position: absolute;
        left: 50%;
        top: 0;
        width:0;
        transform:translate(-50%);
        transition:all 0.3s linear;
        height: 2px;
        background-color: #f75959;
      }
      &.on{
        position: relative;
        color: #f75959;
        background-color: #f8f8f8;
        &:before{
          width:100%;
        }
      }
    }
  }
  .filter-form {
    background-color: #f8f8f8;
    padding: 25px 20px 0px;
    overflow: hidden;
    position: relative;
    padding-right: 90px;
    margin-top: 20px;
    .el-cascader {
      width: 160px;
    }
    .el-date-editor{
      width: 140px;
    }
    .form-item {
      margin-bottom: 16px;
      float: left;
      overflow: hidden;
      margin-right: 20px;
    }
    .btn-group {
      float: right;
    }
    .label {
      float: left;
      font-size: 14px;
      color: #666;
      line-height: 30px;
    }
    .input-item {
      float: left;
      min-width: 160px;
    }
    .input {
      width: 160px;
      border: 1px solid #e5e5e5;
      background-color: #fff;
      padding: 4px 10px;
      font-size: 14px;
      color: #333;
      line-height: 20px;
      height: 30px;
    }
    .unit{
      font-size: 14px;
      color: #666;
      line-height: 30px;
      padding-left: 5px;
      padding-right: 5px;
    }
    .radiobox {
      display: inline-block;
      margin-right: 40px;
      position: relative;
      margin-top: 3px;
      cursor: pointer;
      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        font-size: 100px;
      }
      .radio-text {
        display: inline-block;
        padding: 0 16px;
        font-size: 14px;
        color: #666;
        border-radius: 2px;
        height: 24px;
        line-height: 24px;
        .count{
          color: #f75959;
        }
      }
      input:checked + .radio-text {
        background-color: #f75959;
        color: #fff;
        .count{
          color: #fff;
        }
      }
    }
    .btn-all {
      position: absolute;
      right: 20px;
      top: 25px;
      font-size: 14px;
      .btn-filter-bg {
        height: 30px;
        width: 60px;
        background-color: #f75959;
        color: #fff;
        cursor: pointer;
      }
      .btn-filter-no-bg {
        color: #f75959;
        margin-left: 4px;
        background: none;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .table{
    margin-top: 30px;
    border-collapse: collapse;
    border: 1px solid #e5e5e5;
    width: 100%;
    tr{
      border: 1px solid #e5e5e5;
      &:hover{
        td{
          background-color: #f8f8f8;
        }
      }
    }
    th{
      height: 48px;
      line-height: 48px;
      background-color: #f8f8f8;
      font-size:14px;
      color:#333;
      text-align: left;
      min-width: 80px;
      font-weight: normal;
      &:nth-child(1){
        // text-align: center;
        padding-left: 10px;
      }
    }
    td{
        padding: 5px 0;
        line-height: 24px;
        font-size:14px;
        color:#333;
        text-align: left;
        .item-title {
            .hot {
                display: inline-block;
                vertical-align: middle;
                margin-right: 3px;
            }
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            color: #333;
            font-weight: bold;
            line-height: 24px;
            max-width: 200px;
            min-width: 200px;
        }
        .number-job {
            font-size: 12px;
            color: #999;
            line-height: 22px;
        }
      &:nth-child(1){
        padding-left: 10px;
      }
      &:nth-child(2){
        width: 240px;
      }
    }
    .time{
      word-break: break-all;
    }
    .money{
      color: #f75959;
    }
    .order-no{
      color: #999;
      font-size: 12px;
    }
    .status{
      font-size: 14px;
      color: #999;
      &.status1{
        color: lightgreen
      }
      &.status2{
        color: #f75959
      }
    }
    
    .icon-urgent {
      display: inline-block;
      vertical-align: middle;
      margin-right: 3px;
      width: 36px;
      height: 16px;
      background-image: url('~@/assets/icon-urgent.png');
      background-repeat: no-repeat;
      background-size: contain;
    }
    .icon-hot {
      display: inline-block;
      vertical-align: middle;
      margin-right: 3px;
      width: 26px;
      height: 14px;
      background-image: url('~@/assets/icon-hot.png');
      background-repeat: no-repeat;
      background-size: contain;
    }
    .remark{
      color: #666;
      font-size: 12px;
    }
    .btn-text {
      color: #333;
      font-size: 12px;
      cursor: pointer;
    }
  }
  .el-pagination{
    text-align: right;
    margin-top: 30px;
  }
}
</style>